import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionService } from '../../shared/services/index';
import { ApplicationSubType, Inspection } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit.component.html',
    standalone: false
})
export class InspectionEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  errorMessage: string;
  inspectionId: string;
  statusList: number[];
  categories: any;
  public processing = false;

  constructor(
    public inspectionService: InspectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;
      this.initData();
    });
  }

  saveInspection(inspection: Inspection): void {
    this.processing = true;
    this.inspectionService
      .updateInspectionProperties(inspection.id, {
        name: inspection.name,
        description: inspection.description,
        status: inspection.status,
        coverImage: inspection.coverImage,
        category: inspection.category,
        currency: inspection.currency,
        hourlyRate: inspection.hourlyRate
      })
      .subscribe((el) => {
        this.processing = false;
        this.inspection = el;
        if (this.inspection.applicationSubType === ApplicationSubType.ParentInstallation) {
          this.router.navigate([this.inspectionsRoute, inspection.id, 'inspections']);
          return;
        }
        this.router.navigate([this.inspectionsRoute, inspection.id]);
      });
  }

  cancel(): void {
    this.goToBack();
  }

  initData(): void {
    this.inspectionService.getInspection(this.inspectionId).subscribe((el) => {
      this.inspection = el;
      if (this.inspection.isNew) this.inspection.isNew = false;
      this.inspectionService.getInspectionCategories(el.applicationType).subscribe((categories) => {
        this.categories = categories;
      });
      this.cdf.detectChanges();
    });
    this.statusList = this.inspectionService.getStatusList();
  }
}
